/* eslint-disable no-nested-ternary */
import styled from "styled-components";

const ButtonContainer = styled.button`
  backdrop-filter: blur(10.2528px);
  border-radius: 8px;
  width: 100%;
  height: 2.5rem;
  font-weight: 500;
  font-family: Inter;
  font-size: 14px;
  border: none;
  padding: 8px 0px 8px 0px;
  cursor: pointer;
`;

export const PrimaryButton = styled(ButtonContainer)`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  min-width: fit-content;
  min-height: fit-content;
  background-color: ${(props) => props.color ?? "#2D5BFF"};
  color: white;
`;

export const SecondaryButton = styled(ButtonContainer)`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  min-width: fit-content;
  min-height: fit-content;
  background-color: ${(props) =>
    props.color === "success"
      ? "#4CAF5033"
      : props.color === "error"
      ? "#FFD5D5"
      : props.color === "warning"
      ? "#F8C49A"
      : "#EAEFFF"};
  color: ${(props) =>
    props.color === "success"
      ? "#4CAF50"
      : props.color === "error"
      ? "#F43636"
      : props.color === "warning"
      ? "#ED6C02"
      : "#2D5BFF"};
`;

export const DefaultButton = styled(ButtonContainer)`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  min-width: fit-content;
  min-height: fit-content;
  background-color: white;
  color: #333333;
  border: 1px solid #d0d5dd;
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface ColoredButtonProps {
  isSelected?: boolean;
  disabled?: boolean;
}

export const ColoredButton = styled(ButtonContainer)<ColoredButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.isSelected
      ? "linear-gradient(268.28deg, #06d986 0%, rgba(6, 217, 134, 0) 100%), #4a76fb"
      : "#f2f4f8"};
  color: ${(props) => (props.isSelected ? "white" : "#333333")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 44px;
  padding: 8px 14px 8px 14px;
  gap: 8px;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: none;
  outline: none;
  font-weight: 500;
  font-family: Inter;
  font-size: 14px;
  @media (min-width: 1660px) {
    font-size: 16px;
  }
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
